import { z } from "zod";
import { zBillingPeriod } from "./company.common";
export const zCompanyFinanceSettingsDom = z.object({
    creditLimit: z.number().min(0),
    billingPeriod: zBillingPeriod,
    invoiceIssueDay: z.number().int().min(1).max(28),
    paymentTermDays: z.number().int().min(0).max(365),
    vatRate: z.number().min(0).max(100).nullable(),
});
export const zCompanyFinanceDom = zCompanyFinanceSettingsDom.extend({
    companyId: z.string(),
    name: z.string(),
    status: z.string(),
    balance: z.number(),
    availableCredit: z.number(),
    totalCharged: z.number(),
    totalPaid: z.number(),
    openOrdersCount: z.number(),
    openOrdersExposure: z.number(),
    overdueAmount: z.number(),
    overdueInvoicesCount: z.number(),
    lastInvoiceDate: z.string().nullable(),
    lastPaymentDate: z.string().nullable(),
});
